import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginResultType } from 'src/app/shared/types/auth.types';
import { StorageService } from 'src/app/shared/services/storage/storage.service';
import { StorageKeys } from 'src/app/shared/enums/storage.enum';
import { AuthService } from '../../services/auth/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private storageService: StorageService,
    private authService: AuthService
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (req.url.endsWith('login')) {
      return next.handle(req);
    }

    const authToken = this.storageService.get(StorageKeys.AccessToken);

    if (this.authService.isTokenValid()) {
      req = this.addToken(req, authToken);
    }

    return next.handle(req);
  }

  private addToken(request: HttpRequest<any>, token: LoginResultType) {
    let accessToken = token.accessToken.startsWith('Bearer')
      ? token.accessToken
      : `Bearer ${token.accessToken}`;

    return request.clone({
      setHeaders: {
        Authorization: accessToken,
      },
    });
  }
}
